import { useCallback } from 'react';

import { useConversion } from '@/hooks/query/crypto/useConversion';
import { useLoanTokens } from '@/hooks/query/loans/useLoanTokens';

export const useCalculatePrincipal = () => {
  const { data: tokens } = useLoanTokens();
  const { data: conversions } = useConversion({ symbol: 'ETH', convert: tokens?.filter(({ symbol }) => symbol !== 'NW').map(({ symbol }) => symbol) });

  return useCallback((ltv: number, convertedFloorPrice: number, currency: string) => (convertedFloorPrice && conversions ? Number((ltv * (conversions[0].quote[currency]?.price || 1) * convertedFloorPrice).toFixed(2)) / 100 : 0), [conversions]);
};
